var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitaldashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9473 44.4141H1.80269C0.856723 44.4141 0.0722656 45.1986 0.0722656 46.1446C0.0722656 47.0905 0.856723 47.875 1.80269 47.875H47.9473C48.8932 47.875 49.6777 47.0905 49.6777 46.1446C49.6777 45.1986 48.8932 44.4141 47.9473 44.4141Z",
    fill: "#73C7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4116 0H13.3393C6.41758 0 4.11035 4.12994 4.11035 9.22892V46.1446H17.9537V32.1628C17.9537 30.963 18.9228 29.994 20.1225 29.994H29.6514C30.8281 29.994 31.8202 30.963 31.8202 32.1628V46.1446H45.6635V9.22892C45.6405 4.12994 43.3332 0 36.4116 0ZM30.6435 16.7274H26.6058V20.7651C26.6058 21.711 25.8214 22.4955 24.8754 22.4955C23.9294 22.4955 23.145 21.711 23.145 20.7651V16.7274H19.1073C18.1614 16.7274 17.3769 15.943 17.3769 14.997C17.3769 14.051 18.1614 13.2666 19.1073 13.2666H23.145V9.22892C23.145 8.28295 23.9294 7.49849 24.8754 7.49849C25.8214 7.49849 26.6058 8.28295 26.6058 9.22892V13.2666H30.6435C31.5894 13.2666 32.3739 14.051 32.3739 14.997C32.3739 15.943 31.5894 16.7274 30.6435 16.7274Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitaldashboard);
export default __webpack_public_path__ + "static/media/hospitaldashboard.3befc215fa8f42ab85cb8a8449da2d81.svg";
export { ForwardRef as ReactComponent };